/**
 * ToggleModule - A class for handling functionality
 */
class ToggleModule {
	/**
	 * Setup method
	 * Static method to set up the class on the page
	 *
	 * @return {void}
	 */
	static setup() {
		const elements = document.querySelectorAll('.qte-module-toggle');

		for (const element of elements) {
			const instance = new ToggleModule(element);
			instance.init();
		}
	}

	/**
	 * Constructor method
	 *
	 * @param {HTMLElement} element
	 * @return {void}
	 */
	constructor(element) {
		this.element = element;
	}

	/**
	 * Initialize method
	 * Method to initialize a class instance
	 */
	init() {
		this.addEventListeners();
	}

	/**
	 * Add event listeners
	 *
	 * @return {void}
	 */
	addEventListeners() {
		this.element.addEventListener('click', this.togglItem.bind(this));
	}

	/**
	 * Click to toggle a answer
	 *
	 * @param {Event} e
	 * @return {void}
	 */
	togglItem(e) {
		const toggleItem = e.target.closest('.toggle-item-wrapper');

		if (!toggleItem) {
			return;
		}

		toggleItem.classList.toggle('active');
	}
}

// The document is checked if it is ready. If it is, the setup() method is called.
if (document.readyState === 'interactive' || document.readyState === 'complete') {
	ToggleModule.setup();
} else {
	document.addEventListener('DOMContentLoaded', ToggleModule.setup);
}
